import classNames from "classnames";
import React from "react";

import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { DatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { DateTime } from "luxon";

type Props = {
  onChange: (date: DateTime) => void;
  date: DateTime;
  readOnly: boolean;
  error: string | null;
};

export const ECDatePicker = ({ onChange, date: _date, readOnly, error }: Props) => {
  const [date, setDate] = React.useState(_date.toJSDate());

  React.useEffect(() => {
    setDate(_date.toJSDate());
  }, [_date]);

  const handleNavigateToDate = (dateMoment: MaterialUiPickersDate) => {
    if (!dateMoment) {
      return;
    }

    setDate(DateTime.fromISO(dateMoment.toISOString()).toJSDate());
    onChange(DateTime.fromISO(dateMoment.toISOString(), { zone: getRenderTimeZone() }));
  };

  if (readOnly) {
    return (
      <div className="cw-px-1 cw-py-0.5 cw-h-7 cw-text-default cw-body-sm cw-text-13 cw-font-medium cw-flex cw-items-center">
        {DateTime.fromJSDate(date).toFormat("ccc, MMM dd yyyy")}
      </div>
    );
  }

  return (
    <DatePicker
      id="day-date-picker"
      onChange={handleNavigateToDate}
      value={date}
      variant="inline"
      autoOk
      disableToolbar
      disabled={readOnly}
      format={"ddd, MMMM DD YYYY"}
      className={classNames(
        "cw-h-8 cw-text-13 cw-font-medium",
        "cw-box-border",
        "cw-px-1 cw-h-7",
        "cw-border cw-border-solid",
        "cw-font-body",
        "cw-rounded",
        "cw-transition",
        "cw-outline-1",
        "cw-text-default placeholder:cw-text-subtle",
        "cw-bg-default cw-border-[#FFF] hover:cw-border-subtle-hover focus:cw-border-brand-interactable focus:hover:cw-border-brand-interactable-hover focus-visible:cw-outline-brand-interactable focus:cw-outline-brand-interactable focus:hover:cw-outline-brand-interactable-hover",
        "cw-cursor-pointer",
        "cw-justify-center",
        {
          "cw-bg-destructive cw-outline cw-border-destructive-interactable cw-outline-destructive-interactable hover:cw-border-destructive-interactable-hover hover:cw-outline-destructive-interactable-hover focus-visible:cw-outline-destructive-interactable-pressed focus:cw-outline-destructive-interactable-pressed": error,
        },
      )}
      InputProps={{
        disableUnderline: true,
        classes: {
          root: "cw-cursor-pointer",
          input: classNames("cw-text-13 cw-text-neutral cw-font-medium", "cw-cursor-pointer"),
        },
        label: "Select Month",
        tabIndex: -1,
        role: "presentation",
      }}
    />
  );
};
